export default "__VITE_ASSET__2ICNPqjx__"